import React from "react";

interface BannerComponentProps {}

export const BannerComponent: React.FC<BannerComponentProps> = (
  props: BannerComponentProps
) => {
  return (
    <div className="bg-banner bg-cover bg-no-repeat bg-center">
      <div className="container py-16">
        <h1 className="text-5xl text-white font-medium mb-4 capitalize">
          Smart Shopping Starts Here
        </h1>
        <p className="text-white">
          Discover a seamless online shopping experience with carefully selected
          products across electronics, fashion, and daily essentials. Enjoy
          trusted quality, competitive pricing, and smooth delivery—designed to
          make your everyday shopping faster, easier, and more reliable from
          start to finish.{" "}
        </p>
        <div className="mt-12">
          <a
            href="/shop"
            className="bg-primary border border-primary text-white px-8 py-3 font-medium rounded-md hover:bg-transparent hover:text-primary transition"
          >
            Shop Now
          </a>
        </div>
      </div>
    </div>
  );
};
